import { useEffect } from 'react';
import { useToggleComponent } from 'navigation-components/platform/hooks';
import { GROWTH_PROMPTS_COMPONENT, growthPromptsComponentDef } from 'navigation-components/config';
import { useComponentProps } from 'navigation-components/platform/hooks';
import { captureException } from '../../../utils/sentryAPI';
import { getHasModals } from '../api/getHasModals';
import getWindow from '../../../utils/getWindow';
import { getLocationForModalFetch } from '../utils/getLocationForModalFetch';
import { getContactIdFromUrl } from '../utils/getContactIdFromUrl';
export const LoadGrowthPromptData = () => {
  const {
    href,
    pathname
  } = getWindow().location;
  const {
    toggle
  } = useToggleComponent(GROWTH_PROMPTS_COMPONENT, {
    useScheduler: true
  });
  const updatePromptProps = useComponentProps(growthPromptsComponentDef);
  useEffect(() => {
    getHasModals({
      location: getLocationForModalFetch(new URL(href).pathname),
      windowLocation: pathname,
      contactId: getContactIdFromUrl(href)
    }).then(({
      hasModalsToShow
    }) => {
      if (hasModalsToShow) {
        updatePromptProps({
          hostUrl: href,
          hasPromptsToShow: true
        });
        toggle(true);
      }
    }).catch(error => {
      captureException(error);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // We don't want to render anything in the DOM as this component is just used for its side effect
  return null;
};